import { render, staticRenderFns } from "./TypeListAddNew.vue?vue&type=template&id=f819b53c"
import script from "./TypeListAddNew.vue?vue&type=script&lang=js"
export * from "./TypeListAddNew.vue?vue&type=script&lang=js"
import style0 from "./TypeListAddNew.vue?vue&type=style&index=0&id=f819b53c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports